export enum TEMPLATES {
  VUELTA_AL_COLE_NOVATECH = 1,
  VUELTA_AL_COLE_BANCO_PROVINCIA = 2,
  VUELTA_AL_COLE_CORREO_COMPRAS = 3,
  PERSONAL_DE_SALUD_NOVATECH = 4,
}
